import {
  TimeField as AriaTimeField,
  TimeFieldProps as AriaTimeFieldProps,
  DateInput,
  DateSegment,
  TimeValue
} from 'react-aria-components';
import { cx } from '../../../utils/cx';
import { Label } from '../../base/input/label';
import { ReactNode } from 'react';
import { HintText } from '../../base/input/hint-text';

export type TimeFieldProps = {
  label?: string;
  labelClassName?: string;
  isRequired?: boolean;
  size?: 'sm' | 'md';
  hint?: ReactNode;
} & AriaTimeFieldProps<TimeValue>;

export function TimeField({
  label,
  labelClassName,
  isRequired,
  size = 'md',
  hint,
  ...props
}: TimeFieldProps) {
  const inputTextClass = size === 'sm' ? 'text-sm' : 'text-md';
  return (
    <AriaTimeField
      {...props}
      isRequired={isRequired}
      aria-label={props['aria-label'] || label}
      name={props.name || props['aria-label'] || label}
    >
      {label && (
        <Label className={cx(labelClassName)} isRequired={isRequired}>
          {label}
        </Label>
      )}
      <DateInput
        className={cx(
          'px-3 py-2 bg-primary border border-primary rounded-md shadow-xs'
        )}
      >
        {(segment) => (
          <DateSegment
            segment={segment}
            className={cx('text-primary', inputTextClass)}
          />
        )}
      </DateInput>
      {hint && <HintText>{hint}</HintText>}
    </AriaTimeField>
  );
}
